<template lang="pug">
    div.themesWrapper
        div.themes(:class="{blurry: showPaymentPopup}")
            layout.noBottomMargin.contentTransparent
                v-layout(row wrap)
                    v-flex(xs12 md6)
                        div.pb-3
                            div.themesHeader
                                div
                                    // Banner Title
                                    title-component.bannerTitle(h3 :title="$t('themes.bannerLive.title')")

                                div.text-xs-right.mb-2

                                    // Create Meditation button
                                    button-component.mx-0.my-0.ml-1(
                                        color="action"
                                        v-if="isAdmin"
                                        :action="createSession"
                                        small
                                        style="minWidth: 40px; width: 40px"
                                    ) {{ $t('sessions.list.createButton') }}

                                    // Create Recorded Live button
                                    button-component.mx-0.my-0.ml-1.px-2(
                                        color="action"
                                        v-if="isAdmin"
                                        small
                                        style="minWidth: 70px"
                                        :action="createRecordedSession"
                                    ) {{ $t('sessions.list.createLiveRecordedButton') }}

                            // Banner
                            banner-component(
                                :bannerSession="bannerSession"
                                :moreButtonText="$t('themes.bannerLive.moreButton')"
                                :moreButtonAction="navigateToPlanned"
                                :showPlayer="false"
                            )

                    v-flex(xs12 md6)
                        div.pb-3
                            div.themesHeader
                                div
                                    // Banner Title
                                    title-component.bannerTitle(h3 :title="$t('themes.bannerMinutes.title')")

                                div.text-xs-right.mb-2

                                    // Create Mindful Minute Meditation button
                                    v-btn.mx-0.my-0.ml-1(
                                        color="action"
                                        icon
                                        dark
                                        small
                                        v-if="isAdmin"
                                        @click="createMindfulMinutesSession"
                                    )
                                        v-icon(size="16") add

                            // Banner
                            banner-component(
                                v-if="bannerSessionMinutes.title"
                                :bannerSession="bannerSessionMinutes"
                                :isMindfulMoment="true"
                                :showLikeButton="false"
                                :moreButtonText="$t('themes.bannerMinutes.moreButton')"
                                :moreButtonAction="navigateToMomentsList"
                            )

            layout.contentTransparent(v-if="!showPaymentPopup")
                div.liveHeader
                    div
                        // Themes title
                        title-component.themesTitle.mb-0(h1 :title="$t('themes.title')")

                    div.liveHeaderControls.text-xs-right.mb-2

                        // Instructor filter
                        filter-component.mb-1.mr-4(
                            v-if="!isInstructor"
                            name="Instructor"
                            filterName="instructor"
                            :items="$t('selection.instructors')"
                            :callbackFunction="instructorsFilterCallback"
                        )

                            // Duration filter
                        filter-component.mb-1(
                            name="Duration"
                            filterName="duration"
                            :items="$t('selection.sortDuration')"
                            :callbackFunction="durationFilterCallback"

                        )

                        // Add recorded Meditation button
                        button-component.mr-0.my-0.ml-2(
                            color="action"
                            v-if="isAdmin"
                            :action="addSession"
                        ) {{ $t('sessions.list.createRecordedButton') }}


                div.layoutWrapper.pb-2
                    v-layout(row wrap)

                        v-flex(xs12 lg6)
                            v-layout.themeGrid(row wrap)
                                v-flex(xs6 md6 lg6 xl4 v-for="(item, key) in themes" :key="`wrapper-theme-${key}`")
                                      div.my-2

                                          // Theme card
                                          theme-component(
                                              :key="`theme-${key}`"
                                              :title="item.title"
                                              :image="item.image"
                                              :theme="item.theme"
                                              :status="item.status"
                                              :disabled="item.disabled"
                                              :muted="item.muted"
                                              :duration="item.duration"
                                              :imageAlt="item.imageAlt"
                                          )

                        v-flex(xs12 lg6)
                            div.feedSection
                                title-component.feedTitle(h3 title="Recent Practices")
                                feed

        // Packages
        packages(v-if="showPaymentPopup")
</template>

<script>
    import Theme from '~components/Theme';
    import Layout from '../../Layout/Layout';
    import Banner from '~components/Banner';
    import Button from '~components/Button';
    import Filter from '~components/Filter';
    import Title from '~components/Title';
    import { mapActions, mapGetters } from 'vuex';
    import Packages from '../../../Payments/Packages';
    import List from '../../Feed';

    export default {
        components: {
            Layout,
            Packages,
            ThemeComponent: Theme,
            BannerComponent: Banner,
            FilterComponent: Filter,
            TitleComponent: Title,
            ButtonComponent: Button,
            Feed: List
        },
        computed: {
            ...mapGetters('auth', [
                'user',
                'isAdmin',
                'isInstructor',
                'showPaymentPopup',
                'isGoldman'
            ]),
            ...mapGetters('sessions', ['bannerSession']),
            ...mapGetters('mindfulMinute', ['bannerSessionMinutes']),

            themes() {
                return this.$t('themes.themes');
            },

            /**
             * Navigate to mindful minutes meditations list
             * @returns {*}
             */
            navigateToMindfulMinutes() {
                return (
                    this.isAdmin ||
                    this.user.business_id === '0fffd7ca543d7a55a0050541e0573108'
                );
            }
        },
        async created() {
            this.getBannerSession();
            void this.getBannerSessionMinutes();
            this.getProfile();
        },
        mounted() {
            // Subscribe on meditation status change
            this.sockets.subscribe('general', () => {
                this.getBannerSession();
            });
        },
        beforeDestroy() {
            // Unsubscribe from listening meditation status change
            this.sockets.unsubscribe('general');
        },
        methods: {
            ...mapActions('sessions', ['getBannerSession', 'readInstructors']),
            ...mapActions('mindfulMinute', ['getBannerSessionMinutes']),
            ...mapActions('auth', ['getProfile']),

            navigateToMomentsList() {
                return this.$router.push({
                    name: 'dashboard.mindfulMinutes'
                });
            },

            /**
             * Navigate to planned meditations list
             * @returns {*}
             */
            navigateToPlanned() {
                return this.$router.push({
                    name: 'dashboard.sessions',
                    query: {
                        theme: 'live',
                        title: 'Live'
                    }
                });
            },
            /**
             * Redirect to Create Meditation Page.
             */
            createSession() {
                this.$router.push({ name: 'dashboard.sessions.create' });
            },

            /**
             * Redirect to Create Meditation Page.
             */
            createRecordedSession() {
                this.$router.push({
                    name: 'dashboard.sessions.createRecordedLive'
                });
            },

            /**
             * Redirect to Create Meditation Page.
             */
            createMindfulMinutesSession() {
                this.$router.push({
                    name: 'dashboard.createMindfulMinutes'
                });
            },

            /**
             * Redirect to Create Meditation Page.
             */
            addSession() {
                this.$router.push({
                    name: 'dashboard.sessions.createRecorded'
                });
            },

            durationFilterCallback(e) {
                if (!e.value) return;

                return this.$router.push({
                    name: 'dashboard.sessions',
                    query: {
                        sortBy: 'duration',
                        orderBy: e.value,
                        type: 'recorded'
                    }
                });
            },
            instructorsFilterCallback(e) {
                return this.$router.push({
                    name: 'dashboard.sessions',
                    query: {
                        instructorId: e.value
                    }
                });
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../../../assets/style/_variables.styl"

    .themesWrapper
        position: relative
        min-height: 100%

    .themesHeader
        display: flex
        justify-content: space-between
        align-items: center

    .themes
        padding-top: 15px

    .liveHeader
        display: flex
        justify-content: space-between
        align-items: center

    .noBottomMargin
        >>>
            .container
            .contentInner
                padding-bottom: 0
                margin-bottom: 10px

    .liveHeaderControls
        display: flex
        align-items: center

    @media screen and (max-width: $grid-breakpoints.sm - 1)
        .liveHeader
            flex-direction: column
            justify-content: center

            > div
                width: 100%

            button
                margin: 0 !important
                width: 177px
                min-width: 170px

        .themes
            padding: 20px 0 90px

        >>> .pb-3
            padding-bottom: 12px !important

        .themeGrid >>> .my-2
            margin-top: 0 !important
            margin-bottom: 0 !important

        .themesTitle
            margin-bottom: 8px

        .themesSubHeader
            flex-direction: column

        .liveHeaderControls
            justify-content: space-between

        // Gap between filters and theme grid
        .layoutWrapper
            margin-top: 12px

        // Equal column + row gap: override grid-list-lg margin + flex padding together
        .themeGrid
            margin: -4px !important
        .themeGrid >>> .flex
            padding: 4px !important

        // Feed section separator and title
        .feedSection
            margin-top: 16px
            padding-top: 12px
            border-top: 1px solid rgba(255, 255, 255, 0.1)

        .feedTitle
            margin-bottom: 4px
</style>
